import { getStage } from "../content/stages.js";
import type { Command } from "./types/index.js";

export function startStageCommand(stageId: string): Extract<Command, { type: "START_NEW" | "OPEN_BRING_IN" }> {
  if (getStage(stageId).allowBringIn) {
    return { type: "OPEN_BRING_IN", stageId };
  }
  return { type: "START_NEW", stageId };
}
